<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject"><strong>step 6 | Approval</strong></div>
    <div class="step-wrapper-description step-wrapper-approval mt-4">
      <div v-html="approval_content"></div>
      <label class="step-wrapper-approval-checkbox">
        <div><input type="checkbox" v-on:click="clickApproved" /></div>
        <div>{{approval_note}}</div>
      </label>
    </div>
    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>
  </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  components: {
    jQuery
  },
  data() {
    return {
      approval_content: Stencilease.settings.approval_content,
      approval_note: Stencilease.settings.approval_note
    }
  },
  methods: {
    clickApproved(evt) {
      let obj = evt.target
      this.$store.dispatch('product/SET_APPROVED', jQuery(obj).prop('checked'))
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 5)
      this.$store.dispatch('product/SET_ACTIVETAB', 5)
      this.$store.dispatch('product/SET_ACTIVETAB', 6)
    }
  }
}
</script>
